// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__CVlUw"};